module.exports = __webpack_public_path__ + "static/image1-73e9b33065be9d40e24157c9086e7b85.png";